import getConfig from '@base/lib/config';
import useFlashMessage from '@core/components/FlashMessage';
import {
  selectAudioToPlay,
  setVirtualHumanTalking,
} from '@vh/slices/chat/ChatSlice';
import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const VHAudioPlayer = () => {
  /** @type {React.MutableRefObject<HTMLAudioElement | null>} */
  const audioRef = useRef(null);
  const audioToPlay = useSelector(selectAudioToPlay);
  const dispatch = useDispatch();

  const { addFlashMessage } = useFlashMessage();

  useEffect(() => {
    if (!audioRef.current) return;
    const audio = audioRef.current;
    const callback = () => {
      dispatch(setVirtualHumanTalking(false));
    };
    audio.addEventListener('ended', callback);
    return () => {
      if (!audio) return;
      audio.removeEventListener('ended', callback);
    };
  }, [dispatch]);

  useEffect(() => {
    if (!audioRef.current || !audioToPlay) return;
    console.log(audioToPlay);
    dispatch(setVirtualHumanTalking(true));
    const parsed = JSON.parse(audioToPlay);
    console.log(parsed);
    console.log(parsed.response?.voice);
    if (parsed.response?.voice?.Service?.includes('streaming')) {
      const audioContext = new AudioContext();
      const ws = new WebSocket(
        getConfig('REACT_APP_STREAMED_AUDIO_WEBSOCKET_URL')
      );
      let isClosing = false;
      let timeoutId = null;

      ws.binaryType = 'arraybuffer';

      let audioBufferQueue = [];

      ws.onerror = (error) => {
        console.error('WebSocket error:', error);
        addFlashMessage('Audio streaming error occurred', 'error');
        dispatch(setVirtualHumanTalking(false));
      };

      ws.onopen = () => {
        console.log('send text to stream audio');
        console.log(parsed.response.text);
        ws.send(JSON.stringify(parsed.response.text));
      };

      ws.onmessage = (event) => {
        const arrayBuffer = event.data;
        audioBufferQueue.push(arrayBuffer);
        console.log('WebSocket onmessage');
      };

      ws.onclose = () => {
        console.log('WebSocket closed');
        if (!isClosing) {
          addFlashMessage('Audio streaming connection lost', 'error');
          dispatch(setVirtualHumanTalking(false));
        }
      };

      function playStream() {
        if (isClosing) return;

        console.log('play stream');
        if (audioBufferQueue.length > 0) {
          console.log(audioBufferQueue);
          const arrayBuffer = audioBufferQueue.shift();
          audioContext
            .decodeAudioData(arrayBuffer)
            .then((buffer) => {
              const source = audioContext.createBufferSource();
              source.buffer = buffer;
              source.connect(audioContext.destination);
              source.start();
              source.onended = playStream;
            })
            .catch((error) => {
              console.error('Error decoding audio data:', error);
              addFlashMessage('Error playing audio', 'error');
              dispatch(setVirtualHumanTalking(false));
            });
        } else {
          timeoutId = setTimeout(playStream, 100); // Wait and retry
        }
      }

      playStream();
      return () => {
        isClosing = true;
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        ws.close();
        audioContext.close();
      };
    }
    if (!parsed.response.audio.url) {
      addFlashMessage('No audio to play', 'error');
      return;
    }
    audioRef.current.src = parsed.response.audio.url;
    audioRef.current.play();
  }, [addFlashMessage, audioToPlay, dispatch]);

  return <audio ref={audioRef} controls={false} />;
};

export default VHAudioPlayer;
